import { render } from "./soldierDetailAgreement.vue?vue&type=template&id=2184230a"
import script from "./soldierDetailAgreement.vue?vue&type=script&lang=js"
export * from "./soldierDetailAgreement.vue?vue&type=script&lang=js"

import "./soldierDetailAgreement.vue?vue&type=style&index=0&id=2184230a&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__